import * as React from 'react';
import { NumberField, Select } from '../../components/forms';
import Section from '../../components/Section';
import { Variant } from '../../product';

type Props = {
  variant: Variant;
  setVariant: Function;
};

const setValue = (obj: Variant, onChange: Function) => (
  field: string,
  newValue: any,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

const setInValue = (obj: Variant, onChange: Function) => (
  field: string,
  newValue: any,
) =>
  onChange(
    Object.assign({}, obj, {
      dimensions: {
        ...obj.dimensions,
        [field]: newValue,
      },
    }),
  );

export default function VariantDimensions(props: Props) {
  const handleDimensionsChange = setInValue(props.variant, props.setVariant);
  const handleOnChange = setValue(props.variant, props.setVariant);

  return (
    <Section title="Dimensions and Weight">
      <div className="flex flex-wrap">
        <div className="flex-auto w-50-ns w-100 pr2 flex flex-wrap">
          <div className="w-50-ns pr2">
            <NumberField
              label="Width"
              field={['width']}
              id="width"
              defaultValue={props.variant.dimensions.width}
              onValueChange={handleDimensionsChange}
            />
          </div>
          <div className="w-50-ns pl2">
            <NumberField
              label="Height"
              field={['height']}
              id="height"
              defaultValue={props.variant.dimensions.height}
              onValueChange={handleDimensionsChange}
            />
          </div>
          <div className="w-50-ns pr2">
            <NumberField
              label="Depth"
              field={['depth']}
              id="depth"
              defaultValue={props.variant.dimensions.depth}
              onValueChange={handleDimensionsChange}
            />
          </div>
          <div className="w-50-ns pl2">
            <Select
              label="Unit"
              field={['unit']}
              id="unit"
              options={[
                { label: 'mm', value: 'mm' },
                { label: 'cm', value: 'cm' },
              ]}
              defaultValue={props.variant.dimensions.unit}
              onValueChange={handleDimensionsChange}
            />
          </div>
          <div className="w-50-ns pr2 mt4">
            <NumberField
              label="Weight (In grams)"
              field={['weight']}
              id="weight"
              defaultValue={props.variant.weight}
              onValueChange={handleOnChange}
            />
          </div>
          <div className="w-50-ns pl2 mt4">
            <Select
              label="Unit"
              field={['weight_unit']}
              id="weight_unit"
              options={[
                { label: 'Grams (g)', value: 'g' },
              ]}
              defaultValue={props.variant.weight_unit}
              onValueChange={handleOnChange}
            />
          </div>
        </div>
        <div className="flex-auto w-50-ns w-100 pl2 flex items-center justify-center">
          <img src="/images/dimensions.svg" alt="" />
        </div>
      </div>
    </Section>
  );
}
